/* eslint-disable import/namespace */
import { Auth0Provider } from '@auth0/auth0-react';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import './index.scss';
import { auth0Config } from './lib/config/auth0';
import { store } from './redux/store';

Sentry.init({
  dsn: 'https://4e834e47130e7efefe3c99498ced9212@o4508858886455296.ingest.us.sentry.io/4508858887438336',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/notaryplat\.pages\.io\/v1/,
    /^https:\/\/(\w+)\.notaryplat\.pages\.io\/v1/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// LicenseManager.setLicenseKey(`CompanyName=eNotaryLog,LicensedApplication=eNotaryLog,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=6,LicensedProductionInstancesCount=1,AssetReference=AG-038868,SupportServicesEnd=29_February_2024_[v2]_MTcwOTE2NDgwMDAwMA==640f79aef749e23df16a36e04fa950fa`);

const root = (
  <Auth0Provider {...auth0Config}>
    <Provider store={store}>
      <App />
    </Provider>
  </Auth0Provider>
);

createRoot(document.getElementById('root')!).render(root);
